import React, { useState, useReducer, createElement, useEffect } from "react";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  AppBar,
  Toolbar,
  IconButton,
  useTheme,
  Container,
  Grid,
  MenuItem,
  Menu,
  useMediaQuery,
  withStyles,
  Link,
  SwipeableDrawer,
  TextField,
  TextareaAutosize,
  InputLabel,
  Select,
  FormControl,
  FormHelperText,
  Modal,
  Backdrop,
  Fade,
} from "@material-ui/core";
import divisions from "../divisions.json";
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MenuIcon from "@material-ui/icons/Menu";
import CloseIcon from "@material-ui/icons/Close";
import ScrollTo from "../components/ScrollTo";

// svgs
import { ReactComponent as FbIcon } from "../images/socialIcons/FbIcon.svg";
import { ReactComponent as WhatsApp } from "../images/socialIcons/WhatsApp.svg";
import { ReactComponent as WeChatIcon } from "../images/socialIcons/WeChatIcon.svg";
import { ReactComponent as LineIcon } from "../images/socialIcons/LineIcon.svg";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  const [hideFooter, setHideFooter] = useState("");
  useEffect(() => {
    if (
      pathname === "/log-in" ||
      pathname === "/forget-password" ||
      pathname === "/regist-page" ||
      pathname === "/join-info" ||
      pathname === "/join" ||
      pathname === "/subscribe-page" ||
      pathname === "/buy-house" ||
      pathname === "/consultation" ||
      pathname === "/funds"
    ) {
      setHideFooter(true);
    } else {
      setHideFooter(false);
    }
  });

  if (pathname === "/print") {
    return <Box>{children}</Box>;
  } else {
    return (
      <>
        <Box mb="64px">
          <TopBar />
        </Box>
        <Box>
          {children}
          <ScrollTo />
        </Box>
        <Box>
          {/*NOTE hidefooter true 的話 不顯示 */}
          {!hideFooter && <FooterContent />}
        </Box>
      </>
    );
  }
}

function TopBar() {
  const history = useHistory();
  const useStyles = makeStyles((theme) => ({
    root: {
      "& .MuiToolbar-regular": {
        minHeight: 64,
      },
    },
    menuButton: {
      marginRight: theme.spacing(2),
      "&.MuiIconButton-root": {
        padding: 0,
      },
    },
  }));
  const classes = useStyles();
  //TODO
  return (
    <div className={classes.root}>
      <AppBar position="fixed">
        <Container maxWidth="lg">
          <Toolbar>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              onClick={() => history.push("/")}
            >
              <img src={require("../images/fullLogo.png").default} />
            </IconButton>
            <Box ml="auto">
              <NavList />
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </div>
  );
}

// ANCHOR  NavList
function NavList() {
  const history = useHistory();
  const isDownPc = useMediaQuery("(max-width:1280px)");
  const theme = useTheme();
  const useStyles = makeStyles({
    navBox: {
      display: "flex",
      alignItems: "center",
    },
    menu: {
      "& .MuiMenu-paper": {
        background: "rgba(0,0,0,0.7)",
        padding: "1em 0",
        top: "64px" + " !important",
      },
      "& .MuiMenu-list": {
        padding: "0px",
        paddingRight: "0" + " !important",
        width: "100%" + " !important",
      },
      "& .MuiMenuItem-root": {
        transition: "none",
        margin: 0,
        transform: "none",
      },
      "& .MuiMenuItem-root:hover": {
        background: "rgba(0,0,0,0.7)",
      },
    },
    navLinksPc: {
      position: isDownPc ? "" : "relative",
      display: isDownPc ? "none" : "",
      "&+&::before": {
        content: '""',
        width: "1px",
        height: "16px",
        backgroundColor: "#fff",
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)",
      },
    },
    PhoneMenu: {
      display: isDownPc ? "" : "none",
    },
  });
  const classes = useStyles();
  const openMenuInit = { open: false, anchorEl: null, id: null };
  const [openMenu, openMenuReducer] = useReducer(
    openMenuDispatch,
    openMenuInit
  );
  function openMenuDispatch(_, action) {
    if (action) {
      return { open: true, anchorEl: action.anchorEl, id: action.id };
    } else {
      return openMenuInit;
    }
  }
  function _logout() {
    localStorage.removeItem("@fullhouse-webMemberId");
    localStorage.removeItem("@fullhouse-webToken");
    history.replace("/log-in");
  }
  return (
    <div className={classes.navBox}>
      {/* PC List */}
      <NavListMap
        component={(item) => (
          <Box className={classes.navLinksPc}>
            <Button
              onClick={(e) => {
                item.list
                  ? openMenuReducer({
                      anchorEl: e.currentTarget,
                      id: item.label,
                    })
                  : history.push(item.href);
                if (item.label === "登出") {
                  localStorage.removeItem("@fullhouse-webMemberId");
                  localStorage.removeItem("@fullhouse-webToken");
                }
              }}
              href={item.list ? "javascript:;" : item.href}
            >
              <Box mx={1}>
                <Typography style={{ color: "#fff" }} variant="body2">
                  {item.label}
                </Typography>
              </Box>
            </Button>
            <Menu
              anchorEl={openMenu.anchorEl}
              keepMounted
              disableScrollLock
              open={openMenu.id === item.label}
              anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
              onClose={() => openMenuReducer(null)}
              className={classes.menu}
            >
              <NavListMap
                list={item.list}
                component={(item2) => (
                  <MenuItem
                    disableGutters
                    onClick={() => openMenuReducer(null)}
                  >
                    <Box mx={1} textAlign="center">
                      {/* 這邊 */}
                      <Button fullWidth href={item2.href}>
                        <Typography
                          style={{ color: theme.palette.secondary.light }}
                          variant="body2"
                        >
                          {item2.label}
                        </Typography>
                      </Button>
                    </Box>
                  </MenuItem>
                )}
              />
            </Menu>
          </Box>
        )}
      />
      <Box className={classes.PhoneMenu}>
        <PhoneMenu />
      </Box>
    </div>
  );
}

//ANCHOR 面板特效
const Accordion = withStyles({
  root: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 56,
    "&$expanded": {
      minHeight: 56,
    },
  },
  content: {
    "&$expanded": {
      margin: "12px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);
//ANCHOR Phone Menu
function PhoneMenu() {
  const history = useHistory();
  const isDownPc = useMediaQuery("(max-width:1280px)");
  const [menuToggle, setMenuToggle] = useState(false);
  const theme = useTheme();
  const useStyles = makeStyles({
    menuIcon: {
      position: "relative",
      zIndex: "1001",
      cursor: "pointer",
      transition: "all 0.3s",
      "&:hover": {
        color: theme.palette.grey[300],
      },
    },
    accordingBox: {
      transition: "all 0.1s",
      position: "fixed",
      right: 0,
      top: 0,
      height: "100vh",
      width: menuToggle ? "300px" : "0px",
      zIndex: 1000,
      backgroundColor: "rgba(0,0,0,0.5)",
    },
    accordList: {
      backgroundColor: theme.palette.grey[200],
    },
  });
  const classes = useStyles();
  //
  const [expanded, setExpanded] = useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <div>
      {/* 抽屜 */}
      <Box className={classes.menuIcon}>
        <PhoneMenuDrawer />
      </Box>

      {/* ANCHOR抽屜區域 */}
    </div>
  );
}

function NavListMap({ component = () => {}, list }) {
  const token = localStorage.getItem("@fullhouse-webToken");

  const navList = [
    {
      label: "關於富屋",
      list: [
        { label: "品牌故事", href: "/brand-story" },
        { label: "經營理念", href: "/idea" },
        { label: "經營優勢", href: "/advantage" },
        { label: "隱私條款", href: "/privacy" },
      ],
    },
    {
      label: "法拍查詢",
      list: [
        { label: "簡易查詢", href: `/search?searchType=easy` },
        { label: "詳細查詢", href: `/search?searchType=detail` },
      ],
    },
    {
      label: "最新消息",
      list: [
        { label: "媒體報導", href: `/news/report` },
        { label: "富屋榮耀", href: `/news/glory` },
        { label: "富屋豹報", href: `/news/paper` },
      ],
    },
    {
      label: "服務專區",
      list: [
        { label: "我要買房", href: "/buy-house" },
        { label: "我要諮詢", href: "/consultation" },
        { label: "我要上課", href: "/course" },
        { label: "我要理財", href: "/investment" },
        { label: "我要資金", href: "/funds" },
        { label: "我要整屋", href: "/whole-house" },
      ],
    },
    {
      label: "加盟專區",
      list: [
        { label: "加盟資訊", href: "/join-info" },
        { label: "我要加盟", href: "/join" },
        { label: "加盟店資訊", href: "/join-search" },
        // { label: "我要加盟", href: "/construction-page" },
        // { label: "加盟店資訊", href: "http://www.5137.com.tw/menu/intro.php" },
      ],
    },
    {
      label: "富屋商城",
      list: [
        { label: "資訊訂閱", href: "/subscribe-page" },
        { label: "課程報名", href: "/course-apply" },
        { label: "法拍教材", href: "/textbooks" },
      ],
    },
    { label: token ? "登出" : "登入/註冊", href: "/log-in" },
  ];
  return (list ?? navList).map((item, index) =>
    component({
      label: item.label,
      href: item.href,
      list: item.list?.map((item2) => ({
        label: item2.label,
        href: item2.href,
      })),
    })
  );
}
// Drawer

function PhoneMenuDrawer() {
  const history = useHistory();
  const theme = useTheme();
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };
  const useStyles = makeStyles({
    menuIcon: {
      position: "relative",
      cursor: "pointer",
      transition: "all 5s",
      "&:hover": {
        color: theme.palette.grey[300],
      },
    },
    accordingBox: {
      height: "100vh",
      width: "300px",
      backgroundColor: "rgba(0,0,0,0.1)",
    },
    accordList: {
      backgroundColor: theme.palette.grey[200],
      "&+&": {
        borderTop: `1px solid ${theme.palette.grey[500]}`,
      },
    },
    drawerBox: {
      "& .MuiBackdrop-root": {
        backgroundColor: "transparent" + " !important",
      },
    },
  });
  const classes = useStyles();
  //
  const [expanded, setExpanded] = useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  const [state, setState] = useState({
    right: false,
  });
  return (
    <div>
      {["right"].map((anchor) => (
        <React.Fragment key={anchor}>
          <Box>
            <Button onClick={toggleDrawer(anchor, true)}>
              <IconButton style={{ color: "#fff" }}>
                {toggleDrawer ? <MenuIcon /> : <CloseIcon />}
              </IconButton>
            </Button>
          </Box>

          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
            className={classes.drawerBox}
            swipeAreaWidth={0}
            // transitionDuration={{ enter: 0, exit: 0 } }
          >
            <Box className={classes.accordingBox}>
              <NavListMap
                component={(item) => (
                  <Accordion
                    square
                    expanded={expanded === "panel" + item.label}
                    onChange={handleChange("panel" + item.label)}
                    style={{ backgroundColor: theme.palette.primary.light }}
                  >
                    {/* accordTitle */}
                    <AccordionSummary className={classes.accordTitle}>
                      <Link href={item?.href} underline="none">
                        <Typography variant="body1" style={{ color: "#fff" }}>
                          {item.label}
                        </Typography>
                      </Link>
                    </AccordionSummary>

                    {item.list?.map((item) => {
                      return (
                        // sub內容
                        <AccordionDetails className={classes.accordList}>
                          <Link
                            href={item.href}
                            underline="none"
                            style={{ width: "100%", height: "100%" }}
                          >
                            <Typography>{item.label}</Typography>
                          </Link>
                        </AccordionDetails>
                      );
                    })}
                  </Accordion>
                )}
              />
            </Box>
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}

// ANCHOR Footer

function FooterForm() {
  // const history = useHistory();
  // const location = useLocation();
  // const { control, setValue } = useFormContext();
  const { handleSubmit, control, setValue, register } = useForm({
    defaultValues: {
      fullName: "",
      mobile: "",
      email: "",
    },
  });
  const district = useWatch({ control, name: "district" });
  const divisionList = Object.keys(divisions);
  const subdistrictList = district
    ? Object.keys(divisions[district]["subdivisions"])
    : [];

  //
  const isPhone = useMediaQuery("(max-width:460px)");
  const isDownPc = useMediaQuery("(max-width:960px)");
  const useStyles = makeStyles((theme) => ({
    footerTextArea: {
      padding: "10px",
      outline: "0",
    },
  }));
  const classes = useStyles();

  function _submit(data) {
    const userInput = {
      ...data,
      enabled: true,
    };
    delete userInput.repassword;
    delete userInput.privacy;
    register({ variables: { userInput } });
  }
  return (
    <Box>
      <Grid container spacing={3}>
        <Grid xs={6} item>
          <Controller
            name="userName"
            control={control}
            rules={{
              required: "請填入姓名",
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                label="姓名"
                {...field}
                error={error}
                helperText={error && error.message}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* 電話 */}
        <Grid xs={6} item>
          <Controller
            name="phone"
            control={control}
            rules={{
              required: "請填入電話",
              pattern: {
                value: /^[0-9]{10}$/,
                message: "電話號碼格是錯誤",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                label="電話"
                {...field}
                error={error}
                helperText={error && error.message}
                fullWidth
              />
            )}
          />
        </Grid>

        {/* 性別 */}
        <Grid xs={6} item>
          <Controller
            name="gender"
            control={control}
            rules={{
              required: "請輸入性別",
              pattern: {
                // value: passwordPattern,
                // message: "密碼格式錯誤，需包含英文以及數字！",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <FormControl
                size="small"
                variant="outlined"
                fullWidth
                error={error}
              >
                <InputLabel>性別</InputLabel>
                <Select {...field} label="性別">
                  <MenuItem value={"male"}>男</MenuItem>
                  <MenuItem value={"female"}>女</MenuItem>
                </Select>
                <FormHelperText>{error && error.message}</FormHelperText>
              </FormControl>
            )}
          />
        </Grid>

        <Grid xs={6} md={3} item>
          <Controller
            control={control}
            name="district"
            rules={{
              required: "縣市為必填選項",
            }}
            render={({
              field: { onChange, ...otherField },
              fieldState: { error },
            }) => (
              <FormControl
                size="small"
                variant="outlined"
                fullWidth
                error={error}
              >
                <InputLabel>縣市</InputLabel>
                <Select
                  {...otherField}
                  onChange={(e) => {
                    setValue("subdistrict", "");
                    onChange(e);
                  }}
                  label="縣市"
                >
                  {divisionList.map((item) => (
                    <MenuItem value={item}>{divisions[item]["zhTW"]}</MenuItem>
                  ))}
                </Select>
                <FormHelperText>{error && error.message}</FormHelperText>
              </FormControl>
            )}
          />
        </Grid>

        <Grid xs={6} md={3} item>
          <Controller
            control={control}
            name="subdistrict"
            rules={{
              required: "地區為必填選項",
            }}
            render={({ field, fieldState: { error } }) => (
              <FormControl
                size="small"
                variant="outlined"
                error={error}
                fullWidth
              >
                <InputLabel>地區</InputLabel>
                <Select {...field} label="地區" disabled={!district}>
                  {subdistrictList.map((item) => (
                    <MenuItem value={item}>
                      {divisions[district]["subdivisions"][item]["zhTW"]}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{error && error.message}</FormHelperText>
              </FormControl>
            )}
          />
        </Grid>

        <Grid xs={12} item>
          <Controller
            name="E-Mail"
            control={control}
            rules={{
              required: "請輸入信箱",
              pattern: {
                // value: MailPattern,
                // message: "信箱格式錯誤，需包含英文以及數字！",
              },
            }}
            render={({ field, fieldState: { error } }) => (
              <TextField
                label="信箱"
                {...field}
                error={error}
                helperText={error && error.message}
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={12}>
          <TextareaAutosize
            name="message"
            placeholder="備註"
            style={{
              height: isPhone ? "150px" : "300px",
              width: "100%",
              resize: "none",
              fontSize: "1em",
            }}
            className={classes.footerTextArea}
          />
        </Grid>

        <Grid container justify="center" item xs={12}>
          <Grid item xs={12} md={6}>
            <Box mt={isDownPc ? 4 : ""}>
              <Button
                color="primary"
                variant="contained"
                onClick={handleSubmit(_submit)}
                fullWidth
              >
                傳送
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

function FooterContent() {
  const theme = useTheme();
  const history = useHistory();
  const isTablet = useMediaQuery("(max-width:960px)");
  const isDownSm = useMediaQuery("(max-width:600px)");
  const isPhone = useMediaQuery("(max-width:460px)");
  const useStyles = makeStyles((theme) => ({
    footerLinksList: {
      borderBottom: isDownSm
        ? `1px dotted ${theme.palette.secondary.light}`
        : "",
    },
    footerLinks: {
      color: theme.palette.secondary.light,
      marginTop: isDownSm ? "10px" : "",
      cursor: "pointer",
      lineHeight: "2",
    },
    footerInfoText: {
      letterSpacing: "1.2px",
      lineHeight: 1.6,
    },
    iconBox: {},
    iconButton: {
      transition: "all 0.3s",
      "&+&": {
        marginLeft: "10px",
      },
      "&:hover": {
        transform: "translateY(-10px)",
      },
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));
  const classes = useStyles();

  const footerContact = [
    {
      list: [
        {
          label: "品牌故事",
          href: "/brand-story",
        },
        {
          label: "經營理念",
          href: "/idea",
        },
        {
          label: "經營優勢",
          href: "/advantage",
        },
        {
          label: "隱私條款",
          href: "/privacy",
        },
      ],
    },
    {
      list: [
        // {
        //   label: "簡易查詢",
        //   href: `http://www.5137.com.tw/`,
        // },
        // {
        //   label: "詳細查詢",
        //   href: `http://www.5137.com.tw/fuhoo_index/outlay/search_1.php`,
        // },
        {
          label: "簡易查詢",
          href: `/search?searchType=easy`,
        },
        {
          label: "詳細查詢",
          href: `/search?searchType=detail`,
        },
      ],
    },
    {
      list: [
        {
          label: "媒體報導",
          href: `/news/report`,
        },
        {
          label: "富屋榮耀",
          href: `/news/glory`,
        },
        {
          label: "富屋豹報",
          href: `/news/paper`,
        },
      ],
    },
    {
      list: [
        {
          label: "我要買房",
          href: "/buy-house",
        },
        {
          label: "我要諮詢",
          href: "/consultation",
        },
        {
          label: "我要上課",
          href: "/course",
        },
        { label: "我要理財", href: "/investment" },
        { label: "我要資金", href: "/funds" },
        { label: "我要整屋", href: "/whole-house" },
      ],
    },
    // {
    //   list: [
    //     {
    //       label: "加盟介紹",
    //       href: "/join-info",
    //     },
    //     {
    //       label: "我要加盟",
    //       href: "/construction-page",
    //     },
    //     {
    //       label: "我要加盟",
    //       href: "/join",
    //     },
    //     {
    //       label: "加盟店資訊",
    //       href: "http://www.5137.com.tw/menu/intro.php",
    //     },
    //     {
    //       label: "加盟店資訊",
    //       href: "/join-search",
    //     },
    //   ],
    // },
    // {
    //   list: [
    //     {
    //       label: "資訊訂閱",
    //       href: "/construction-page",
    //     },
    //     {
    //       label: "課程報名",
    //       href: "/construction-page",
    //     },
    //     {
    //       label: "法拍教材",
    //       href: "/construction-page",
    //     },
    //   ],
    // },
  ];

  const footerList = [
    {
      list: [
        {
          label1: "富屋實業有限公司",
          label2: "總部地址：台中市南屯區大英西一街61號",
        },
      ],
    },
    {
      list: [
        {
          label1: "傳真：(04)2473-3106",
          label2: "電話：(04)2471-7673",
          label3: "加盟專線：0800-800-680",
        },
      ],
    },
  ];

  // NOTE 暫時按鈕
  const tempararyBtn = [
    {
      label: "物件推薦專區",
      href: "http://www.5137.com.tw/",
    },
    {
      label: "查看加盟店資訊",
      href: "http://www.5137.com.tw/menu/intro.php?page=1",
    },
    {
      label: "留言諮詢",
      href: "http://www.5137.com.tw/fuhoo_index/gbook/index.php",
    },
  ];
  return (
    <Box pt={4}>
      <Container maxWidth="xl">
        <Grid container spacing={2}>
          {/* 左資訊區塊 */}
          {/*原本md={6} 暫時md={12}*/}
          <Grid container item xs={12} md={12}>
            <Grid
              item
              container
              justifyContent="center"
              xs={12}
              style={{
                flexDirection: "column",
                alignItems: "center",
                display: isDownSm ? "" : "none",
                marginBottom: "2em",
              }}
            >
              <Box>
                <img
                  src={require("../images/mapMark.png").default}
                  style={{ maxWidth: "100%" }}
                />
              </Box>
              <Box pt={4}>
                <Typography variant="body2" color="primary">
                  富屋法拍屋，法拍業界的領導品牌
                  <br />
                  全國第一通過ISO9001國際品質標準認證
                </Typography>
              </Box>
            </Grid>
            {/* list 選單 */}
            <Grid
              container
              item
              justifyContent="center"
              xs={12}
              style={{
                borderTop: `1px solid ${theme.palette.secondary.light}`,
                borderBottom: `1px solid ${theme.palette.secondary.light}`,
                padding: "1em 0",
              }}
            >
              {/* link列表 */}
              {footerContact.map((item, index) => {
                return (
                  <Grid item sm={2} xs={12} md={1}>
                    <Box
                      py={2}
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      className={
                        index == footerContact.length - 1
                          ? ""
                          : classes.footerLinksList
                      }
                    >
                      {item.list.map((item) => {
                        return (
                          <Link
                            className={classes.footerLinks}
                            onClick={() => history.push(item.href)}
                          >
                            {item.label}
                          </Link>
                        );
                      })}
                    </Box>
                  </Grid>
                );
              })}

              {/* 暫時區域 */}
              <Grid
                item
                container
                justifyContent="center"
                sm={6}
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                  display: isDownSm ? "none" : "",
                }}
              >
                <Box pt={2} display="flex" justifyContent="center">
                  <img
                    src={require("../images/mapMark.png").default}
                    style={{ maxWidth: "50%" }}
                  />
                </Box>
                <Box py={4}>
                  <Typography variant="body1" color="primary">
                    富屋法拍屋，法拍業界的領導品牌
                    <br />
                    全國第一通過ISO9001國際品質標準認證
                  </Typography>
                </Box>
              </Grid>
            </Grid>

            {/* footer之 list */}
            <Grid container item xs={12} style={{ margin: "2em 0" }}>
              {footerList.map((item, index) => {
                return (
                  <Grid item container xs={index == 2 ? 12 : 12} md={6}>
                    {item.list.map((item) => {
                      return (
                        // 這邊
                        <Box pl={isPhone ? "" : 4} mt={2}>
                          <Typography
                            variant="body2"
                            component={index == 2 ? "span" : ""}
                            className={classes.footerInfoText}
                            style={{ color: theme.palette.primary.light }}
                          >
                            {item.label1}
                          </Typography>
                          <Typography
                            variant="body2"
                            component={index == 2 ? "span" : ""}
                            className={classes.footerInfoText}
                            style={{ color: theme.palette.primary.light }}
                          >
                            {item.label2}
                          </Typography>
                          <Typography
                            variant="body2"
                            component={index == 2 ? "span" : ""}
                            className={classes.footerInfoText}
                            style={{ color: theme.palette.primary.light }}
                          >
                            {item.label3}
                          </Typography>
                        </Box>
                      );
                    })}
                  </Grid>
                );
              })}
            </Grid>
          </Grid>

          {/* ANCHOR 右邊form區塊 */}
          {/* NOTE 聯絡我們 */}
          {/* <Grid
            item
            container
            justify="center"
            alignItems="center"
            xs={12}
            md={6}
          >
            <Grid xs={12} item>
              <Box mb={2}>
                <Typography variant="h6" color="textSecondary">
                  聯絡我們
                </Typography>
              </Box>
            </Grid>
            <Grid xs={12} item>
              <FooterForm />
            </Grid>
          </Grid> */}
        </Grid>

        {/* copyright */}
        <Grid container item xs={12}>
          <Grid item xs={12}>
            {/* footer Icons */}

            <FooterIconsModal />
          </Grid>
          <Grid item xs={12}>
            <Box py={2}>
              <Typography
                variant={isPhone ? "caption" : "body2"}
                align="center"
                style={{ color: theme.palette.primary.light }}
              >
                Copyright &copy; 2021 富屋實業有限公司 版權所有
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

function FooterIconsModal() {
  const isPhone = useMediaQuery("(max-width:600px)");
  const useStyles = makeStyles((theme) => ({
    iconBox: {},
    iconButton: {
      transition: "all 0.3s",
      "&+&": {
        marginLeft: "10px",
      },
      "&:hover": {
        transform: "translateY(-10px)",
      },
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
    sgvIcon: {
      width: "16px",
      height: "16px",
    },
  }));
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const footerIcons = [
    {
      name: "Facebook",
      svg: FbIcon,
      href: "https://www.facebook.com/fuhoohouse/",
    },
    {
      name: "Line",
      svg: LineIcon,
      href: "https://lin.ee/t4fbbTg",
    },
    {
      name: "WhatsApp",
      svg: WhatsApp,
      href: "https://pse.is/3jyhtf",
    },
    {
      name: "WeChat",
      svg: WeChatIcon,
      modalImg: require("../images/socialIcons/weChatQrCode.webp").default,
    },
  ];
  return (
    <div>
      <Box
        mt={2}
        display="flex"
        justifyContent="center"
        className={classes.iconBox}
      >
        {/* svg icons */}
        {footerIcons.map((item) => {
          return (
            <>
              <IconButton
                size="small"
                className={classes.iconButton}
                onClick={item.href ? null : handleOpen}
                href={item.href ? item.href : "javascript:;"}
              >
                {createElement(item.svg)}
              </IconButton>
              <Modal
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                  timeout: 500,
                }}
              >
                <Fade in={open}>
                  <div className={classes.paper}>
                    <img src={item.modalImg} />
                  </div>
                </Fade>
              </Modal>
            </>
          );
        })}
      </Box>
    </div>
  );
}
